export default __webpack_public_path__ + "static/media/cola.a81f762a.jpeg";